export * from "./mail-address";
export * from "./postal-code";
export * from "./prefecture";
export * from "./telephone-number";
//# sourceMappingURL=index.js.map